var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowNextBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.62774 11.25C1.73979 11.2503 1.8505 11.2256 1.95173 11.1776C2.05297 11.1296 2.14215 11.0595 2.21274 10.9725L5.83524 6.47246C5.94555 6.33826 6.00586 6.16993 6.00586 5.99621C6.00586 5.82249 5.94555 5.65416 5.83524 5.51996L2.08524 1.01996C1.95794 0.8668 1.77501 0.770482 1.57669 0.752197C1.37837 0.733912 1.18091 0.795159 1.02774 0.922463C0.874581 1.04977 0.778264 1.2327 0.759979 1.43102C0.741694 1.62934 0.80294 1.8268 0.930244 1.97996L4.28274 5.99996L1.04274 10.02C0.951032 10.1301 0.892774 10.2641 0.874865 10.4063C0.856955 10.5484 0.880142 10.6927 0.941684 10.8221C1.00323 10.9515 1.10055 11.0606 1.22213 11.1364C1.34371 11.2122 1.48447 11.2516 1.62774 11.25Z",
    fill: "#D0D0D0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNextBack);
export default __webpack_public_path__ + "static/media/arrow-next_back.111e7219d99bc3d9d6a1d3a8ddc22d2a.svg";
export { ForwardRef as ReactComponent };